import React from 'react';

function MultimediaComponent() {
    return <div>MultimediaComponent</div>;
}

export default MultimediaComponent;
